import type { SocialPlatformId } from '@shopgnd/shared';
import { getRuntimeSiteSocialLinks, runtimeSiteSocialSameAs } from '@/lib/platformSiteSocial';

export type SiteSocialPlatform = Extract<
  SocialPlatformId,
  'instagram' | 'facebook' | 'x' | 'linkedin' | 'youtube'
>;

export type SiteSocialLink = {
  platform: SiteSocialPlatform;
  href: string;
  label: string;
};

/** Footer / public site social profiles (admin override via PlatformSettings, else JSON defaults). */
export function getSiteSocialLinks(): SiteSocialLink[] {
  return getRuntimeSiteSocialLinks().links;
}

/** Schema.org sameAs URLs for Organization graph. */
export function siteSocialSameAs(): string[] {
  return runtimeSiteSocialSameAs();
}
